import React from 'react'

const Icon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M4.83979 15.5833H11.5833V11.5833H15.5833V4.83979C15.5833 4.76493 15.5593 4.70347 15.5112 4.65542C15.4632 4.60736 15.4017 4.58333 15.3269 4.58333H4.83979C4.76493 4.58333 4.70347 4.60736 4.65542 4.65542C4.60736 4.70347 4.58333 4.76493 4.58333 4.83979V15.3269C4.58333 15.4017 4.60736 15.4632 4.65542 15.5112C4.70347 15.5593 4.76493 15.5833 4.83979 15.5833ZM4.83979 16.6667C4.47007 16.6667 4.15431 16.5358 3.8925 16.2742C3.63083 16.0124 3.5 15.6966 3.5 15.3269V4.83979C3.5 4.47007 3.63083 4.15431 3.8925 3.8925C4.15431 3.63083 4.47007 3.5 4.83979 3.5H15.3269C15.6966 3.5 16.0124 3.63083 16.2742 3.8925C16.5358 4.15431 16.6667 4.47007 16.6667 4.83979V11.7869L11.7869 16.6667H4.83979ZM6.45188 11.359V10.2756H10.0833V11.359H6.45188ZM6.45188 8.375V7.29167H13.7148V8.375H6.45188Z'
        fill='#686867'
      />
    </svg>
  )
}

export default Icon
